"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _RoutedLink = _interopRequireDefault(require("./RoutedLink"));

var MenuLink =
/*#__PURE__*/
(0, _styled.default)(_RoutedLink.default, {
  rootEl: 'a',
  target: "e1s7lmdh0"
})(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'block',
    color: theme.dimmedTextColor,
    textDecoration: 'none',
    fontSize: '13px',
    lineHeight: '16px',
    padding: '1px 5px 4px',
    marginLeft: '5px',
    position: 'relative',
    zIndex: 1
  };
}, function (_ref2) {
  var active = _ref2.active;
  return active ? {
    color: 'inherit',
    fontWeight: 'bold',
    backgroundColor: 'rgba(0,0,0,0.07)',
    zIndex: 0
  } : {};
});
MenuLink.propTypes = {
  active: _propTypes.default.bool
};
var _default = MenuLink;
exports.default = _default;